export default [
  {value: 'RESTAURANT', label: 'Reštaurácia'},
  {value: 'SHOP', label: 'Obchod'},
  {value: 'BISTRO', label: 'Bistro'}
]



// WEBPACK FOOTER //
// ./client/codelist/businessTypes.js